<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container" style="height: 1900px">
        <div class="modal-header">
          <h3>Termet dhe kushtet e regjistrimit ne Marimanga</h3>
          <a @click="getShowModal(false)" style="font-size:25px;font-weight:bold;">x</a>
        </div>
        <iframe src="/pdf/default.pdf" height="100%" width="100%"></iframe>

        <div class="modal-footer">
          <button @click="getShowModal(false, $event)">Mbylle</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 60%;
  max-height: 900px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
}

.modal-header h3 {
  margin-top: 0;
  color: black;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


<script>
export default {
  name: "TCModal",
  methods: {
    getShowModal(value) {
      this.$store.dispatch("billing/getShowModal", value);
    },
    getAgreeToTerms(value) {
      this.$store.dispatch("billing/getAgreeToTerms", value);
      this.$store.dispatch("billing/getShowModal", false);
    }
  }
};
</script>

